export const AGENTS = {
  myrealtrip: 'MYREALTRIP',
  waug: 'WAUG',
  trimo: 'TRIMO',
} as const;

export type AgentType = typeof AGENTS[keyof typeof AGENTS];
